/**
 * ikiink (user mandate 2026-09-12): product gallery clips are always-playing
 * <video autoplay muted loop playsinline> elements rendered by
 * snippets/product-media.liquid. The autoplay attribute alone is not enough:
 * Chromium defers the autoplay decision for videos that are not rendered at
 * decision time (mobile carousel slides), browsers may pause muted clips on
 * visibility flips or power saving, and section re-renders (variant changes)
 * morph in fresh <video> nodes. This module re-kicks any paused clip whenever
 * it is (or becomes) visible.
 */

const SELECTOR = 'video.product-media__video';

/** @param {Element} video */
function play(video) {
  if (video instanceof HTMLVideoElement && video.paused) {
    // Belt and braces: the muted IDL attribute can be lost on cloned or
    // morphed nodes even when the content attribute is present.
    video.muted = true;
    video.play().catch(() => {});
  }
}

const intersection = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) play(entry.target);
  }
});

function watch() {
  for (const video of document.querySelectorAll(SELECTOR)) {
    if (video instanceof HTMLVideoElement && !video.dataset.clipWatched) {
      video.dataset.clipWatched = 'true';
      intersection.observe(video);
      play(video);
    }
  }
}

watch();
new MutationObserver(watch).observe(document.body, { childList: true, subtree: true });
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    for (const video of document.querySelectorAll(SELECTOR)) play(video);
  }
});
